import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { Router } from "@angular/router";
import { map, tap, timeout, retry, catchError } from "rxjs/operators";
import { AppConfig } from "usermanagement-boothelp/src/app/app-config.module"
import { IResponse } from "usermanagement-boothelp/src/app/shared/models/response.model";
import { IAuthUser, ICheckForgotPassword } from "usermanagement-boothelp/src/app/shared/models/auth.model";

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private config: AppConfig
  ) {}

  login(username: string, password: string): Observable<IResponse<IAuthUser>> {
    return this.http
      .post<IResponse<IAuthUser>>(`${this.config.apiEndpoint}/users/login`, {
        username: username,
        password: password,
      })
      .pipe(
        timeout(this.config.apiTimeout),
        retry(this.config.apiRetry),
        map((res) => {
          if (res.status && res.status.toLowerCase() === "success") {
            sessionStorage.setItem("currentUser", JSON.stringify(res.data));
          }
          return res;
        })
      );
  }

  getSession(username: string, password: string): Observable<IResponse<IAuthUser>> {
    return this.http
      .post<IResponse<IAuthUser>>(`${this.config.apiEndpoint}/users/getsession`, {
        username: username,
        password: password,
      })
      .pipe(
        timeout(this.config.apiTimeout),
        retry(this.config.apiRetry),
        map((res) => {
          if (res.status && res.status.toLowerCase() === "success") {
            sessionStorage.setItem("currentUser", JSON.stringify(res.data));
          }
          return res;
        })
      );
  }

  logout(): Observable<IResponse<string>> {
    return this.http
      .post<IResponse<string>>(`${this.config.apiEndpoint}/users/logout`, {})
      .pipe(
        timeout(this.config.apiTimeout),
        retry(this.config.apiRetry),
        tap((res) => {
          sessionStorage.removeItem("currentUser");
          sessionStorage.removeItem("permissionList");
          sessionStorage.removeItem("_session");
          this.router.navigate(["/auth/login"]);
        }),
        catchError((err) => {
          return this.errorHandler(err);
        })
      );
  }

  forgotPassword(email: string): Observable<IResponse<void>> {
    return this.http
      .post<IResponse<void>>(`${this.config.apiEndpoint}/users/forgotpassword`, {
        email: email
      });
  }

  forgotPasswordCheck(code: string): Observable<IResponse<ICheckForgotPassword>> {
    return this.http
      .post<IResponse<ICheckForgotPassword>>(`${this.config.apiEndpoint}/users/forgotpasswordcheck`, {
        code: code
      })
      .pipe(
        timeout(this.config.apiTimeout),
        retry(this.config.apiRetry),
        map((res) => {
          return res;
        })
      );
  }

  forgotPasswordChange(code: string, password: string): Observable<IResponse<void>> {
    return this.http
      .post<IResponse<void>>(`${this.config.apiEndpoint}/users/forgotpasswordchange`, {
        code: code,
        password: password
      })
      .pipe(
        timeout(this.config.apiTimeout),
        retry(this.config.apiRetry),
        map((res) => {
          return res;
        })
      );
  }

  errorHandler(error: HttpErrorResponse) {
    sessionStorage.removeItem("currentUser");
    sessionStorage.removeItem("permissionList");
    sessionStorage.removeItem("_session");
    return throwError(() => error.message || "server error.");
  }
}
